var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 20V18.5H3.525V17.45C3.125 17.45 2.775 17.3 2.475 17C2.175 16.7 2.025 16.35 2.025 15.95V4.5C2.025 4.1 2.175 3.75 2.475 3.45C2.775 3.15 3.125 3 3.525 3H20.475C20.875 3 21.225 3.15 21.525 3.45C21.825 3.75 21.975 4.1 21.975 4.5V15.95C21.975 16.35 21.825 16.7 21.525 17C21.225 17.3 20.875 17.45 20.475 17.45V18.5H24V20H0ZM3.525 15.95H20.475V4.5H3.525V15.95ZM3.525 15.95V4.5V15.95Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPc);
export default __webpack_public_path__ + "static/media/pc.5e89ac5a1e997f5bb2e0646af5bad7a6.svg";
export { ForwardRef as ReactComponent };